<template>
  <div class="leavers">
    <v-form>
      <v-row>
        <v-col cols="12">
          <v-btn depressed color="primary" :disabled="!canEditLeaver" @click="editLeaver(null)"
            >New Record</v-btn
          >
        </v-col>
        <v-spacer></v-spacer>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :items="leaverList"
            dense
            class="searchResults"
            @click:row="editLeaver"
            item-key="ExitId"
            :items-per-page="-1"
            :loading="loading"
            loading-text="Loading leaver list..."
            :single-select="true"
            :calculate-widths="true"
          >
            <template
              v-for="header in headers.filter((header) => header.format !== '')"
              v-slot:[`item.${header.value}`]="{ item, value }"
            >
              {{ formatTableEl(item, value, header.format) }}
            </template>
            <template v-slot:[`item.ExitDate`]="{ item }">
              <span>{{ displayDate(new Date(item.ExitDate)) }}</span>
            </template>
          </v-data-table>

          <Sidebar
            :isShown="isSidebarShown"
            :isNew="isNew"
            :isLeaver="true"
            :showViewResults="calculatedValues.length > 0"
            :showQuoteButton="calculatedValues.length > 0"
            :formElements="formElements"
            :elements="pensionItems"
            :planId="currentPlanId"
            :membershipId="memberId"
            :exitId="exitId"
            :sidebarName="sidebarName"
            :isFormValid="isFormValid"
            :defaultTabLabel="defaultTabLabel"
            :actionsDisabled="!canEditLeaver"
            @form-validity="isFormValid = $event"
            @delete="onDelete"
            @cancel="cancelChanges"
            @save="saveChanges"
            @calculationButtonClick="onButtonClick"
          >
          </Sidebar>

          <v-dialog v-model="showCalculation" max-width="500" persistent>
            <Calculation
              formName="Deferred"
              :currentPlanId="currentPlanId"
              :selectedMemberId="memberId"
              @calculateClick="onCalculateClick"
            />
          </v-dialog>

          <v-dialog v-model="showCalculatedMessages" max-width="500" persistent>
            <CalculatedMessages
              :messages="calculatedMessages"
              @closeMessages="showCalculatedMessages = false"
            />
          </v-dialog>

          <v-dialog v-model="showCalculatedValues" max-width="500" persistent scrollable>
            <CalculatedValues :values="calculatedValues" @closeResults="showCalculatedValues = false" />
          </v-dialog>

          <v-dialog v-model="showQuote" max-width="900" width="900" persistent>
            <Letters
              @closeQuote="showQuote = false"
              :memberId="memberId"
              :calculationResults="calculationResults"
              formName="Leaver"
            />
          </v-dialog>
        </v-col>
      </v-row>
    </v-form>
    <Dialog ref="confirmationDialog"></Dialog>
  </div>
</template>

<script>
import Dialog from '@/components/layout/Dialog.vue';
import Utils from '@/utils.js';
import Sidebar from '@/components/layout/Sidebar.vue';
import Calculation from './Calculation.vue';
import CalculatedValues from './CalculatedValues.vue';
import CalculatedMessages from './CalculatedMessages.vue';
import Letters from './Letters.vue';

export default {
  components: {
    Dialog,
    Sidebar,
    Calculation,
    CalculatedValues,
    Letters,
    CalculatedMessages,
  },
  name: 'Exit',

  props: {},

  data() {
    return {
      currentPlan: 0,
      loading: false,
      isSidebarShown: false,
      sidebarName: 'leaver record',
      formElements: [],
      allElements: [],
      headers: [],
      leaverList: [],
      selectedLeaver: null,
      isFormValid: false,
      dialog: false,

      showCalculation: false,
      calculatedValues: [],
      calculatedMessages: [],
      calculatedElements: [],
      showCalculatedMessages: false,
      showCalculatedValues: false,
      showQuote: false,
      calculationResults: [],
      pensionItemsCopy: [],

      defaultTabLabel: 'Exit Data',
      
    };
  },

  computed: {
    memberId() {
      return this.$store.state.selectedMemberId;
    },
    isNew() {
      if (this.selectedLeaver) return false;
      return true;
    },
    currentPlanId() {
      return this.$store.getters.currentPlanId;
    },
    canEditLeaver() {
      const userPermission = this.$store.getters.getUserPermission(this.$route.path);
      if (userPermission && userPermission == 'Full') return true;

      return false;
    },
    pensionItems() {
      if (this.selectedLeaver != null && Object.keys(this.selectedLeaver).length) {
        return this.selectedLeaver.PensionItems;
      }
      return [];
    },
    exitId() {
      if (this.selectedLeaver != null && Object.keys(this.selectedLeaver).length) {
        return this.selectedLeaver.ExitId;
      }
      return 0;
    },
  },

  watch: {
    memberId() {
      this.getLeaverList();
    },
  },

  created() {
    this.getHeaders();
  },

  mounted: function () {
    if (!this.memberId) {
      this.$store.commit('setNotificationMessage', {
        type: 'info',
        text: 'Please, select member',
      });
      this.$router.push({ path: '/' });
    } else {
      this.getForm('Deferred');
      this.$root.currentPage = 'Leavers';
    }
  },

  methods: {
    displayDate(date) {
      if (date.getFullYear() <= 1900) return null;
      return Utils.getDateStr(date);
    },

    editLeaver(item) {
      if (!item && !this.canEditLeaver) return;
      this.isSidebarShown = true;
      if (item) {
        this.getLeaverById(item.ExitId);
      } else {
        this.formElements.forEach((el) => (el.Value = ''));
        this.selectedLeaver = null;
      }
    },

    cancelChanges() {
      this.isSidebarShown = false;
      this.selectedLeaver = null;
    },

    saveChanges() {
      if (this.isFormValid) {
        this.isSidebarShown = false;
        if (this.isNew) {
          this.addLeaver();
        } else {
          this.updateLeaver();
        }
      }
    },

    async onDelete() {
      try {
        await this.$refs.confirmationDialog.open(
          'Confirmation',
          'Are you sure you wish to delete this record?'
        );
        this.isSidebarShown = false;
        this.deleteLeaver();
      } catch (err) {
        console.log();
      }
    },

    formatTableEl(item, value, format) {
      return Utils.formatTableValue(value, format);
    },

    async addLeaver() {
      const newLeaver = {};
      this.allElements.forEach((el) => {
        newLeaver[el.FieldName] = el.Value;
      });
      this.formElements.forEach((el) => {
        newLeaver[el.FieldName] = el.Value;
      });
      newLeaver.MembershipID = this.memberId;
      try {
        await this.$api.post(`/exit/InsertExitDeferred`, newLeaver);

        this.$store.commit('setNotificationMessage', { type: 'success', text: 'Record was added' });
        this.getLeaverList();
      } catch (err) {
        console.log(err.message);
      }
    },

    async updateLeaver() {
      this.loading = true;
      try {
        this.formElements.forEach((el) => {
          this.selectedLeaver[el.FieldName] = el.Value;
        });

        await this.$api.post(`/exit/UpdateExitDeferred`, this.selectedLeaver);

        this.$store.commit('setNotificationMessage', {
          type: 'success',
          text: 'Record was updated',
        });
        this.getLeaverList();
      } catch (err) {
        console.log(err.message);
      }
    },

    async deleteLeaver() {
      this.loading = true;
      try {
        await this.$api.delete('/exit/DeleteExitDeferred?Id=' + this.selectedLeaver.ExitId);

        this.$store.commit('setNotificationMessage', {
          type: 'success',
          text: 'Record was deleted',
        });
        this.getLeaverList();
      } catch (err) {
        console.log(err.message);
      } finally {
        this.loading = false;
      }
    },

    async getLeaverList() {
      this.loading = true;
      try {
        let response = await this.$api.get(
          '/exit/GetExitDeferredListByMember?membershipid=' + this.memberId
        );

        this.leaverList = response.data;
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },

    async getLeaverById(id) {
      try {
        let response = await this.$api.get('/exit/GetExitDeferredById?exitId=' + id);
        this.selectedLeaver = response.data;
        var data = response.data;

        if (!response.data) {
          const msg = 'Can not find record with id ' + id;
          this.$store.commit('setNotificationMessage', { type: 'error', text: msg });
          throw new Error(msg);
        }
        // match data with form fields
        if (data) Utils.setDataToFormElements(data, this.formElements);
      } catch (err) {
        console.error(err);
      }
    },
    async getForm(formName) {
      try {
        let response = await this.$api.get(
          `/datadictionary/GetFormElements?formName=${formName}&planId=${this.currentPlanId}`
        );

        this.allElements = response.data;
        this.formElements = response.data.filter((f) => f.Visible == true);

        this.getLeaverList();
      } catch (err) {
        console.error(err);
      }
    },
    async getHeaders() {
      try {
        const response = await this.$api.get(
          `/datadictionary/GetGridHeaders?formName=ExitDeferred&planId=${this.currentPlanId}`
        );

        if (response.data.length) {
          const data = response.data.filter((item) => item.Visible);
          data.sort((a, b) => a.ColumbOrder - b.ColumbOrder);
          this.headers = data.map((item) => ({
            text: item.HeaderText,
            value: item.Datafield,
            align: item.Align.toLowerCase(),
            format: item.FieldFormat,
          }));
        }
      } catch (err) {
        console.log(err.message);
      }
    },

    async onButtonClick(val) {
      if (val === 'calculate') {
        this.showCalculation = true;
      } else if (val === 'viewResults') {
        this.showCalculatedValues = true;
      } else if (val === 'quote') {
        this.showQuote = true;
      }
    },

    onCalculateClick(val, data) {
      if (val === 'cancel') {
        this.showCalculation = false;
      } else if (val === 'calculate') {
        this.showCalculation = false;
        if (data) {
          this.calculationResults = data;
          this.calculatedValues = data.Values || [];
          this.calculatedMessages = data.Messages || [];
          this.calculatedElements = data.Elements || [];

          if (this.calculatedMessages.length) {
            console.log(data.Messages.length);
            this.showCalculatedMessages = true;
          }

          if (data.Elements && data.Elements.length) {
            this.selectedLeaver.PensionItems = [...this.calculatedElements];
          }

          if (data.Values && data.Values.length) {
            data.Values.forEach((value) => {
              const updatingEl = this.formElements.find((el) => el.FieldId === value.FieldName);
              if (updatingEl) {
                updatingEl.Value = value.Value;
              }
            });
          }
        }
      }
    },
    
  },
};
</script>

<style lang="scss">
.leavers {
  margin-bottom: 10px;
  padding-left: 30px;
  padding-right: 30px;

  .footerBtns {
    background-color: white;
    padding: 10px 20px;
  }

  .v-tabs {
    margin-bottom: 10px;

    .v-tabs-slider-wrapper {
      width: 0px !important;
      height: 0px !important;
    }

    .v-tab {
      border: 1px solid;
      border-radius: 30px;
      color: #4a1cd4 !important;
      height: 35px;
      margin-right: 10px;

      &.v-tab--active {
        color: white !important;
        background-color: #4a1cd4;
      }
    }
  }
}

</style>
